<template>
    <div>

        <div class="card bg-light mb-0">

            <div
                    class="card-header bg-dark text-white d-flex justify-content-between align-items-center"
            >
                <h6 class="mb-0">
                    <font-awesome-icon icon="list" />
                    Payroll View
                </h6>
            </div>

            <div class="card-body bg-white position-relative">

                <!-- LOADER -->
                <b-row align-v="center" class="loader" v-if="is_saving">
                    <b-col>
                        <b-spinner></b-spinner>
                        <br><br>
                        <strong>Loading</strong>
                    </b-col>
                </b-row>

                <b-form @submit.prevent="confirm">

                    <!-- HEADER -->
                    <b-row
                            class="m-0 mb-3"
                            v-if="typeof payroll.project.title != 'undefined'"
                    >

                        <b-col class="p-0 pr-1">

                            <b-row class="m-0">

                                <b-col
                                        cols="1"
                                        class="text-center p-2 bg-info text-white d-flex align-items-center justify-content-center"
                                >
                                    <font-awesome-icon icon="map-marker" class="h2 mb-0" />
                                </b-col>

                                <b-col
                                        class="p-2 bg-white d-flex align-items-center border"
                                >

                                    <div>

                                        <h6 class="mb-0 text-muted">
                                            Project
                                        </h6>

                                        <h6 class="mb-0">
                                            <strong>
                                                {{ payroll.project.title }}
                                            </strong>
                                        </h6>

                                    </div>

                                </b-col>

                            </b-row>

                        </b-col>

                        <b-col class="p-0 px-1" cols="3">

                            <b-row class="m-0">

                                <b-col
                                        cols="2"
                                        class="text-center p-2 bg-info text-white d-flex align-items-center justify-content-center"
                                >
                                    <font-awesome-icon icon="calendar" class="h2 mb-0" />
                                </b-col>

                                <b-col
                                        class="p-2 bg-white d-flex align-items-center border"
                                >

                                    <div>

                                        <h6 class="mb-0 text-muted">
                                            Date
                                        </h6>

                                        <h6 class="mb-0">
                                            <strong>
                                                {{ payroll.date_from.other_formats.format_3 }}
                                                -
                                                {{ payroll.date_to.other_formats.format_3 }}
                                            </strong>
                                        </h6>

                                    </div>

                                </b-col>

                            </b-row>

                        </b-col>

                        <b-col class="p-0 pl-1" cols="3">

                            <b-row class="m-0">

                                <b-col
                                        cols="2"
                                        class="text-center p-2 bg-info text-white d-flex align-items-center justify-content-center"
                                >
                                    <font-awesome-icon icon="check-circle" class="h2 mb-0" />
                                </b-col>

                                <b-col
                                        class="p-2 bg-white d-flex align-items-center border"
                                >

                                    <div>

                                        <h6 class="mb-0 text-muted">
                                            Total
                                        </h6>

                                        <h6 class="mb-0">
                                            <strong>
                                                <number-format-component
                                                        :input_value="Number(total)"
                                                />
                                            </strong>
                                        </h6>

                                    </div>

                                </b-col>

                            </b-row>

                        </b-col>

                    </b-row>

                    <!-- TABLE -->
                    <div class="table-responsive">

                        <table class="table table-bordered mb-0 mt-3">

                            <thead class="bg-light text-dark">

                            <!-- ROW 1 -->
                            <tr>

                                <th rowspan="2">
                                    EMPLOYEE
                                </th>
                                <th rowspan="2">
                                    DESIGNATION
                                </th>

                                <!-- DYNAMIC DATES -->
                                <th
                                        v-for="date in payroll_dates"
                                        :key="date"
                                        colspan="3"
                                        class="text-center"
                                        style="white-space: pre-line;"
                                >
                                    {{ formatDate(date) }}
                                </th>

                                <th class="text-center" colspan="2">
                                    TOTAL HOURS
                                </th>

                                <th rowspan="2" class="text-center">
                                    TOTAL DAYS
                                </th>


                                <th rowspan="2" class="text-center">
                                    TOTAL AMOUNT
                                </th>

                                <th rowspan="2" class="text-center">
                                    SIGNATURE
                                </th>

                            </tr>

                            <!-- ROW 2 -->
                            <tr>

                                <!-- REG OT AMOUNT -->
                                <template v-for="date in payroll_dates">

                                    <th
                                            :key="date + '-reg'"
                                            class="text-center"
                                    >
                                        REG
                                    </th>

                                    <th
                                            :key="date + '-ot'"
                                            class="text-center"
                                    >
                                        OT
                                    </th>

                                    <th
                                            :key="date + '-amount'"
                                            class="text-center"
                                    >
                                        AMT
                                    </th>

                                </template>

                                <th class="text-center">
                                    REG
                                </th>

                                <th class="text-center">
                                    OT
                                </th>



                            </tr>

                            </thead>

                            <tbody>

                            <tr
                                    v-for="(payroll_detail, index) in payroll.payroll_details"
                                    :key="index"
                            >

                                <!-- EMPLOYEE -->
                                <td>
                                    {{ payroll_detail.manpower.full_name }}
                                </td>


                                <!-- DESIGNATION -->
                                <td>
                                    {{ payroll_detail.manpower.job_description.manpower_job_description.description }}
                                </td>

                                <!-- DAILY LOGS -->
                                <template v-for="date in payroll_dates">

                                    <!-- REG -->
                                    <td
                                            :key="date + '-regular-' + index"
                                            class="text-center"
                                    >

                                        {{
                                        getLog(payroll_detail.logs, date)
                                        ? Number(
                                        getLog(payroll_detail.logs, date).regular_hours
                                        ).toFixed(1)
                                        : '0.0'
                                        }}

                                    </td>

                                    <!-- OT -->
                                    <td
                                            :key="date + '-ot-' + index"
                                            class="text-center"
                                    >

                                        {{
                                        getLog(payroll_detail.logs, date)
                                        ? Number(
                                        getLog(payroll_detail.logs, date).ot_hours
                                        ).toFixed(1)
                                        : '0.0'
                                        }}

                                    </td>

                                    <!-- AMOUNT -->
                                    <td
                                            :key="date + '-amount-' + index"
                                            class="text-right"
                                    >

                                        <number-format-component
                                                :input_value="
                          getLog(payroll_detail.logs, date)
                          ? Number(
                              getLog(payroll_detail.logs, date).total
                            )
                          : 0
                        "
                                                :currency="false"
                                        />

                                    </td>

                                </template>

                                <!-- TOTAL HOURS -->
                                <td class="text-center">

                                    <number-format-component
                                            :input_value="
                        Number(payroll_detail.total_regular_hours)
                      "
                                            :currency="false"
                                            :decimal="1"
                                    />

                                </td>

                                <td class="text-center">

                                    <number-format-component
                                            :input_value="
                        Number(payroll_detail.total_ot_hours)
                      "
                                            :currency="false"
                                            :decimal="1"
                                    />

                                </td>

                                <!-- DAYS -->
                                <td class="text-center">

                                    <number-format-component
                                            :input_value="
                        Number(payroll_detail.total_days)
                      "
                                            :currency="false"
                                            :decimal="1"
                                    />

                                </td>

                                <!-- TOTAL PAYOUT -->
                                <td class="text-right">

                                    <number-format-component
                                            :input_value="
                        Number(payroll_detail.total_payout)
                      "
                                    />

                                </td>

                                <td></td>

                            </tr>

                            </tbody>

                            <!-- FOOTER -->
                            <tfoot class="bg-light text-dark">

                            <tr>

                                <th
                                        class="text-right"
                                        :colspan="(payroll_dates.length * 3) + 5"
                                >
                                    GRAND TOTAL PAYOUT
                                </th>

                                <th class="text-right">

                                    <number-format-component
                                            :input_value="Number(total)"
                                    />

                                </th>

                                <th></th>

                            </tr>

                            </tfoot>

                        </table>

                    </div>

                </b-form>

            </div>

        </div>

    </div>
</template>

<script>

    import { bus } from '@/main.js';
    import SwalMixin from '@/views/mixins/Swal.js';
    import NumberFormatComponent
        from '@/views/helpers/NumberFormatComponent.vue';

    export default {

        mixins:[SwalMixin],

        components:{
            NumberFormatComponent
        },

        data: () => {

            return {

                payroll:{
                    project:{},
                    payroll_details:[],
                },

                is_saving:false,

            }
        },

        watch: {

            payroll:{

                immediate:true,

                deep:true,

                handler(){

                    this.payroll.payroll_details.forEach(
                        (value, index) => {

                            value.total_payout =
                                Number(value.initial_payout)
                                -
                                (
                                    Number(value.ca_payment)
                                    +
                                    Number(value.sss_payment)
                                    +
                                    Number(value.philhealth_payment)
                                    +
                                    Number(value.pagibig_payment)
                                    +
                                    Number(value.other_payment)
                                );

                        }
                    );

                }

            }

        },

        computed: {

            payroll_dates(){

                let dates = [];

                if(
                    !this.payroll.date_from ||
                    !this.payroll.date_to
                ){
                    return dates;
                }

                let current = new Date(
                    this.payroll.date_from.default
                );

                let end = new Date(
                    this.payroll.date_to.default
                );

                while(current <= end){

                    dates.push(
                        current.toISOString().split('T')[0]
                    );

                    current.setDate(
                        current.getDate() + 1
                    );

                }

                return dates;

            },

            total(){

                return this.payroll.payroll_details.reduce(
                    (total, value) => {

                        return total + Number(value.total_payout);

                    },0
                );

            }

        },

        created(){

            this.is_saving = true;

            let params = {
                id:this.$route.params.id
            }

            this.axios.get(
                'payroll/get',
                {
                    params:params
                }
            ).then(response => {

                this.payroll = response.data;

                this.is_saving = false;

            }).catch(error => console.log(error));

        },

        methods: {

            formatDate(date){

                let d = new Date(date);

                let weekday = d.toLocaleDateString(
                    'en-US',
                    {
                        weekday:'short'
                    }
                ).toUpperCase();

                let day = String(d.getDate()).padStart(2, '0');

                let month = d.toLocaleDateString(
                    'en-US',
                    {
                        month:'short'
                    }
                ).toUpperCase();

                let year = String(d.getFullYear()).slice(-2);

                return `${weekday}\n${day}-${month}-${year}`;

            },

            getLog(logs, date){

                if(!logs){
                    return null;
                }

                return logs.find(log => {

                    let logDate = new Date(
                        log.transaction_date
                    )
                        .toISOString()
                        .split('T')[0];

                    return logDate === date;

                });

            }

        }

    }
</script>

<style>
    @media print {
        @page {
            size: landscape;
            margin: 10mm;
        }

        body {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }

        /* Optional: make table fit better */
        table {
            width: 100%;
            font-size: 10px;
        }

        th, td {
            padding: 4px !important;
            white-space: nowrap;
        }

        /* Hide buttons, inputs, etc. when printing */
        button,
        .btn,
        input,
        .form-control {
            display: none !important;
        }
    }
</style>